import React from 'react';

import { Flex, FlexProps, Space, Text } from '@mantine/core';
import { FloatingSide } from '@mantine/core/lib/Floating';
import { InfoComponent } from 'components/InfoComponent';

interface InputLabelWithInfoProps extends FlexProps {
  label: string | React.ReactNode;
  infoContentTranslationKey: string;
  infoPosition?: FloatingSide;
  image?: string;
  tooltipWidth?: number;
  rightSection?: React.ReactNode;
}

export function InputLabelWithInfo({
  label,
  infoContentTranslationKey,
  infoPosition,
  image,
  tooltipWidth,
  rightSection,
  ...flexProps
}: InputLabelWithInfoProps) {
  return (
    <Flex direction="row" align="center" mb={2} gap={5} {...flexProps}>
      {typeof label === 'string' ? (
        <Text truncate fz={flexProps.fz} fw={flexProps.fw}>
          {label}
        </Text>
      ) : (
        label
      )}
      <InfoComponent
        contentTranslationKey={infoContentTranslationKey}
        position={infoPosition}
        image={image}
        width={tooltipWidth}
        withinPortal={true}
      />
      {rightSection && (
        <>
          <Space w={5} />
          {rightSection}
        </>
      )}
    </Flex>
  );
}
